import store from '../store/modules/common-data';

export default {
  inserted(el, binding, vnode) {
    if (binding.value !== undefined) {
      setTimeout(() => {
        const permissions = store.state.permissions;
        const isSuperAdmin = store.state.isSuperAdmin;
        const values = binding.value.split(',');
        const hasPermission = values.some(v => permissions[v]) || isSuperAdmin;

        if (!hasPermission) {
          vnode.elm.parentElement.removeChild(vnode.elm);
          // OR
          // el.parentNode.removeChild(el);
        }
      }, 100);
    }
  },
};



// WEBPACK FOOTER //
// ./src/directives/HasPermission.js